import commonMapping from "@/mapping/common";

const server_mode_list = [
  { id: "ntp_use_default", value: "default", config: "default", label: "ntp_use_default" },
  { id: "ntp_use_preferred", value: "manual", config: "manual", label: "ntp_use_manual" },
];

export const ntpSettings = {
  server_mode: server_mode_list,
  daylight_enable: commonMapping.intToBoolean,
};

export default ntpSettings;
